import { isEmpty } from 'lodash'

import { ActivityLogMutations } from './partials/activity-log'
import { AssociateRecordMutations } from './partials/associate-records'
import { PrintRecordMutations } from './partials/print-record'
import { RecordEditMutations } from './partials/edit'
import { partyName } from '@/utilities'

export const RecordMutations = {
  ...ActivityLogMutations,
  ...AssociateRecordMutations,
  ...PrintRecordMutations,
  ...RecordEditMutations,

  setRecord (state, value) {
    // providing an empty value allows for reset of "current" record
    state.record = isEmpty(value)
      ? value
      : {
          title: partyName(value?.record_holder_party),
          ...value,
        }
  },

  setRecords: (state, value) => {
    state.records = value
  },

  setSearchLoading: (state, value) => {
    state.isSearching = value
  },

  updateRecord (state, value) {
    state.record[value.field] = value.data
  },
}
